
import React from "react";
import { Header } from "@/components/Header";

export const LoadingScreen = () => {
  return (
    <>
      <Header showSearchAndLocation={false} />
      <div className="container mx-auto px-4 py-8 pt-28">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        </div>
      </div>
    </>
  );
};
